/**
 * Public app version reported to TelemetryDeck and other release metadata.
 * Bump only when Nick approves a new release number.
 *
 * APP_RELEASE_TITLE is used by GitHub Actions for the release display name:
 *   "{APP_VERSION} - {APP_RELEASE_TITLE}"  e.g. "1.0.1 - Address autocomplete…"
 * Keep APP_VERSION and APP_RELEASE_TITLE each on a single line so CI can parse them.
 * Update the title whenever you bump APP_VERSION.
 */
export const APP_VERSION = '1.2.1';

/** Short label for the GitHub Release title (not sent to TelemetryDeck). */
export const APP_RELEASE_TITLE = 'Public landing URLs and Search Console sitemap';
